import { render, staticRenderFns } from "./ScrollNav.vue?vue&type=template&id=0f2519da&scoped=true&"
import script from "./ScrollNav.vue?vue&type=script&lang=js&"
export * from "./ScrollNav.vue?vue&type=script&lang=js&"
import style0 from "./ScrollNav.vue?vue&type=style&index=0&id=0f2519da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2519da",
  null
  
)

export default component.exports